/*
 * Copyright (c) 2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import clsx from "clsx";
import {CheckIcon} from "@heroicons/react/20/solid";
import {PackagesCartItem} from "types/entities/PackagesCartItem";
import {toast} from "react-toastify";
import {useDispatch} from "useDispatch";
import {Reservation} from "types/entities/Reservation";
import SellerAction from "store/seller/SellerAction";
import {useForm} from "react-hook-form";

const SellerPackageCartItemRowCustomText = (props: {packagesCartItem: PackagesCartItem; reservation: Reservation}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const {
        register,
        handleSubmit,
        reset,
        setValue,
        watch,
    } = useForm({
        defaultValues: {
            custom_text: props.packagesCartItem.custom_text ?? "",
        },
    });
    const customText = watch("custom_text");
    const isNotUpdatedValue = (props.packagesCartItem?.custom_text && props.packagesCartItem.custom_text !== customText) || (!props.packagesCartItem?.custom_text && customText !== "");

    const onSubmitCustomTextHandler = () => {
        dispatch(SellerAction.fetchChangeUpsellPriceAndQuantity(props.reservation.id, props.packagesCartItem, "custom_text", customText)).then(r => {
            toast.success(t("Upsell changed"));
        });
    };

    useEffect(() => {
        setValue(
            "custom_text",
            props.packagesCartItem.custom_text ?? "",
        );
    }, [props.packagesCartItem]);

    return (
        <form onSubmit={handleSubmit(onSubmitCustomTextHandler)}
              className={"SellerPackageCartItemRowCustomText flex flex-col items-end gap-y-1 min-w-[250px] max-w-[300px] xl:max-w-[90%]"}>
            <textarea
                className={"w-full px-1.5 py-1 rounded-md text-gray-600 border-gray-200 border"}
                placeholder={"Note"}
                {...register("custom_text")}
                rows={3}
                style={{resize: "vertical"}}
            />
            <button
                className={clsx(
                    " text-white flex items-center justify-center h-[30px] font-medium leading-tight py-1 px-2 rounded-md w-full md:w-auto",
                    isNotUpdatedValue ? "border-green-400 bg-green-400" : "cursor-not-allowed border-gray-300 bg-gray-300 hidden",
                )}
                type={"submit"}
            >
                <CheckIcon className={"w-4 h-4 flex-none mr-1"} />
                <span>{t("Save")}</span>
            </button>
        </form>
    );
};

export default SellerPackageCartItemRowCustomText;
